//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import algoliasearch from 'algoliasearch';
export default {
  props: {
    placeholder: {
      type: String
    },
    lang: {
      type: String
    },
    emptyText: {
      type: String
    }
  },
  data() {
    return {
      index: null,
      query: '',
      isEmpty: false,
      langs: {
        'zh-CN': {
          search: '搜索文档',
          empty: '无匹配结果',
          index: 'zh'
        },
        'en-US': {
          search: 'Search',
          empty: 'No results',
          index: 'en'
        },
        'es': {
          search: 'Buscar',
          empty: 'No hay datos que coincidan',
          index: 'es'
        }
      }
    };
  },
  computed: {
  },
  watch: {
    lang() {
      this.initIndex();
    }
  },
  methods: {
    initIndex() {
      const client = algoliasearch('NZ3JK4XEDL', 'bfc8efd7f20e6ad6d32b0fd3379fcc86');
      this.index = client.initIndex(this.lang);
    },
    querySearch(query, cb) {
      if (!query) return;
      this.index.search({ query, hitsPerPage: 50 }, (err, res) => {
        if (err) {
          console.error(err);
          return;
        }
        if (res.hits.length > 0) {
          this.isEmpty = false;
          cb(res.hits.map(hit => {
            let content = hit._highlightResult.title.value.replace(/\s+/g, ' ');
            const highlightStart = content.indexOf('<span class="algolia-highlight">');
            if (highlightStart > -1) {
              const startEllipsis = highlightStart - 15 > 0;
              content = (startEllipsis ? '...' : '') +
                content.slice(Math.max(0, highlightStart - 15), content.length);
            } else if (content.indexOf('|') > -1) {
              content = '';
            }
            return {
              anchor: hit.anchor,
              url: hit.url,
              component: hit.component,
              highlightedCompo: hit._highlightResult.title.value,
              title: hit._highlightResult.title.value.replace(/<em>/g, '<em class="algolia-highlight">'),
              content: content.replace(/<em>/g, '<em class="algolia-highlight">'),
              category: hit.category
            };
          }).sort((a, b) => {
            if (a.category === '组件' || a.category === 'Component') {
              return -1
            }
            return 1
          }).concat({ img: true }));
        } else {
          this.isEmpty = true;
          cb([{ isEmpty: true }]);
        }
      });
    },
    handleSelect(val) {
      if (!val.url) return;
      this.$router.push(val.url)
    }
  },
  mounted() {
    this.initIndex();
  }
};



// WEBPACK FOOTER //
// ./src/algolia-search.vue